import type { SchemaProperty } from 'types/schema';
import type { SphereSectionSlot, SphereSectionSlotContext } from '../../sphereSectionSlots';
import MetricIndicatorsSlotMolecule from './MetricIndicatorsSlotMolecule';
import { composedMetricProperties } from './composedMetricProperties';
import { shownIndicators, sphereIndicatorsStore } from './sphereIndicatorsStore';

/**
 * The Indicators section: applies once a saved sphere has a readable or unavailable indicator (an outage is
 * shown, not hidden), when the read
 * failed (never rendered as empty) and while a retry of that failure runs, or while loading if the section
 * already holds composed metrics.
 * A re-read keeps the indicators already shown, so the section and its cards stay mounted while it runs.
 * In view mode the cards own the composed metric properties; edit mode keeps the grid input.
 */
export const metricsSectionSlot: SphereSectionSlot = {
  appliesTo: (ctx: SphereSectionSlotContext) => {
    if (!ctx.sphere.id) return false;
    const state = sphereIndicatorsStore.peek(ctx.sphere.id);
    if (state.status === 'failed' || (state.status === 'loading' && state.failedReads !== undefined)) return true;
    const shown = shownIndicators(state);
    if (shown) return shown.some((i) => i.access !== 'restricted');
    return composedMetricProperties(ctx).length > 0;
  },
  ownsProperty: (prop: SchemaProperty, ctx: SphereSectionSlotContext) => {
    if (ctx.mode !== 'view' || !ctx.sphere.id || !prop.aspect_system_name) return false;
    const shown = shownIndicators(sphereIndicatorsStore.peek(ctx.sphere.id)) ?? [];
    return shown.some(
      (i) => i.attachmentId === null && i.access === 'readable' && i.aspectSystemName === prop.aspect_system_name,
    );
  },
  Component: MetricIndicatorsSlotMolecule,
  dataSource: sphereIndicatorsStore,
};
